<template>
  <div id="organization">
    <TopList :navList="navList" @setType="setType"></TopList>
    <OrDetails
      @getDetails="getDetails"
      :orInfo="orInfo"
      :orgPeriodical="orgPeriodical"
      v-if="type === 0"
    ></OrDetails>
  </div>
</template>

<script>
import TopList from "../../components/topList";
import OrDetails from "./components/orDetails";
export default {
  name: "index",
  components: {
    TopList,
    OrDetails,
  },
  data() {
    return {
      navList: ["机构信息"],
      type: 0,
      orInfo: {},
      orgPeriodical: {},
    };
  },
  created() {
    this.getDetails();
  },
  methods: {
    setType(num) {
      this.type = num;
      this.getDetails();
    },
    async getDetails() {
      let result = await this.$apis.userServe.getOrDetails();
      this.orInfo = result.content.orgInfo;
      this.orgPeriodical = result.content.orgPeriodical["1"];
      console.log(this.orInfo, "this.orInfo");
      console.log(this.orgPeriodical, "this.orgPeriodical");
    },
  },
};
</script>

<style lang="scss" scoped>
#organization {
}
</style>
